/**** mgt.Stops */
import { apiTypes } from 'shared/consts/handbooksApiTypes';

const config = {
  schema: 'mgt',
  table: 'Stops',
  title: 'Остановочные пункты',
  apiType: apiTypes.DEFAULT,
  elemsOnPage: 100,
  fields: [
    {
      name: 'stop_id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
    },
    {
      name: 'stop_name',
      title: 'Наименование',
      type: 'text',
      required: true,
    },
    {
      name: 'note',
      title: 'Альтернативное наименование',
      type: 'text',
      required: false,
    },
    {
      name: 'stop_lat',
      title: 'Широта',
      type: 'text',
      required: false,
      hide: true,
    },
    {
      name: 'stop_lon',
      title: 'Долгота',
      type: 'text',
      required: false,
      hide: true,
    },
    {
      title: 'Координаты',
      type: 'composite',
      disableSort: true,
      composite: {
        type: 'point_coords',
        lat: 'stop_lat',
        lon: 'stop_lon',
      },
      width: '200px'
    },
    {
      name: 'do_not_update',
      title: 'Отключить автообновление',
      type: 'boolean',
      required: false,
      width: '205px',
    },
  ],
  newTemplate: {
    stop_id: null,
    stop_name: '',
    note: '',
    stop_lat: 0,
    stop_lon: 0,
    do_not_update: true,
  },
  makeIdOnInsert: true,
  defaultSort: {
    field: 'stop_id',
    direction: 'desc',
  },
  import: {
    header: [
      {
        title: 'stop_id',
        field: 'stop_id',
      },{
        title: 'stop_name',
        field: 'stop_name',
      },
      {
        title: 'stop_alt_name',
        field: 'note',
      },
      {
        title: 'stop_lat',
        field: 'stop_lat',
      },
      {
        title: 'stop_lon',
        field: 'stop_lon',
      }
    ],
    example: `1;Название остановки;Stop name;59.918077;30.304900`,
  },
  export: {
    fields: [
      {
        name: 'stop_name',
        title: 'Наименование',
      },
      {
        name: 'note',
        title: 'Альтернативное наименование',
      },
      {
        name: 'coords',
        title: 'Координаты',
        format: {
          fields: ['stop_lat', 'stop_lon'],
          template: '%1;%2',
        },
        defaultValue: '000.00000;000.00000'
      },
    ],
  },
};

export default config;
